module.exports = __webpack_public_path__ + "static/media/logoLetmiEcu.9556cf91.svg";